// import React, { createContext, useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import * as api from "../api/index";
// import {  getUnitMappings } from "../actions/unitActions"; // Import action to fetch mappings

// const StockContext = createContext();

// const StockProvider = ({ children }) => {
//   const [trackStock, setTrackStock] = useState(false);
//   const [stock, setStock] = useState([]);
//   const dispatch = useDispatch();
//   const mappings = useSelector((state) => state.units.mappings); // Get mappings from Redux

//   // Fetch unit mappings once when the provider mounts
//   useEffect(() => {
//     dispatch(getUnitMappings());
//   }, [dispatch]);

//   const getCurrentStockQty = async (itemId) => {
//     try {
//       const { data } = await api.getCurrentStockQuantity(itemId);
//       console.log(data);
//       const currentStock = parseFloat(data.currentStock);
//       return { currentStock };
//     } catch (error) {
//       console.log(error.response);
//       return { currentStock: 0 };
//     }
//   };

//   const getConvertedQuantity = (item, type = "sale", targetUnitId) => {
//     try {
//       const fromUnitId = item?.units?.[type]?.unit?.id;
//       const toUnitId = targetUnitId || item?.units?.stock?.unit?.id; // Default to stock unit
//       const mapping = mappings.find(
//         (m) => m.fromUnit.toString() === fromUnitId && m.toUnit.toString() === toUnitId
//       );
//       const convertedQuantity = mapping
//         ? item.quantity * mapping.conversionFactor
//         : item.quantity; // Fallback to raw quantity if no mapping
//       return convertedQuantity * (type === "sale" ? -1 : 1); // Negative for sales
//     } catch (error) {
//       console.log(error);
//       return 0;
//     }
//   };

//   const contextValue = {
//     stock,
//     trackStock,
//     setTrackStock,
//     getCurrentStockQty,
//     getConvertedQuantity,
//   };

//   return (
//     <StockContext.Provider value={contextValue}>
//       {children}
//     </StockContext.Provider>
//   );
// };

// export { StockContext, StockProvider };

import React, { createContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../api/index";
import {  getUnitMappings } from "../actions/unitActions";

const StockContext = createContext();

const StockProvider = ({ children }) => {
  const [trackStock, setTrackStock] = useState(false);
  const [stock, setStock] = useState([]);
  const dispatch = useDispatch();
  const mappings = useSelector((state) => state.units.mappings);

  useEffect(() => {
    dispatch(getUnitMappings());
  }, [dispatch]);

  const getCurrentStockQty = async (itemId) => {
    try {
      const { data } = await api.getCurrentStockQuantity(itemId);
      console.log(data);
      const currentStock = parseFloat(data.currentStock);
      console.log(currentStock)
      return { currentStock };
    } catch (error) {
      console.log(error.response);
      return { currentStock: 0 };
    }
  };
  

  // const getConvertedQuantity = (item, type = "sale", targetUnitId, convert = true) => {
  //   try {
  //     const toUnitId = String(item?.units?.[type]?.unit?.id);
  //     const fromUnitId = String(targetUnitId || item?.units?.stock?.unit?.id);
  //     const mapping = mappings.find((m) => {
  //       const fromUnitStr = String(m.fromUnit.id || m.fromUnit);
  //       const toUnitStr = String(m.toUnit.id || m.toUnit);
  //       const match = fromUnitStr === toUnitId && toUnitStr === fromUnitId;
  //       console.log(`Checking mapping in getConvertedQuantity: ${fromUnitStr} -> ${toUnitStr}, Match: ${match}`);
  //       return match;
  //     });
  
  //     let convertedQuantity = item.quantity;
  //     console.log(item)
  //     if (convert && mapping) {
  //       convertedQuantity = item.quantity *(1 / mapping.conversionFactor);
  //       console.log(`Converted ${item.quantity} from ${fromUnitId} to ${toUnitId}, Factor: ${(1 / mapping.conversionFactor)}, Result: ${convertedQuantity}`);
  //       convertedQuantity *= (type === "sale" ? -1 : 1); // Negate only if converting
  //     } else {
  //       console.log(`No conversion applied: ${item.quantity} remains in ${fromUnitId}`);
  //     }
  
  //     return convertedQuantity;
  //   } catch (error) {
  //     console.log(error);
  //     return 0;
  //   }
  // };

  const getConvertedQuantity = (item, type = "sale", targetUnitId, convert = true) => {
    console.log('getConvertedQuantity inputs:', { item, type, targetUnitId, convert });
  
    // Validate item structure
    if (!item?.units?.[type]?.unit?.id || !item?.units?.stock?.unit?.id) {
      console.error(`Invalid item structure for type ${type}:`, item);
      return 0;
    }
  
    const toUnitId = String(item.units[type].unit.id); // Sale unit ID
    const fromUnitId = String(targetUnitId || item.units.stock.unit.id); // Stock unit ID or target
  
    console.log(`toUnitId: ${toUnitId}, fromUnitId: ${fromUnitId}`);
  
    // If units match, return quantity (negate for sales)
    if (toUnitId === fromUnitId) {
      const result = type === "sale" ? -item.quantity : item.quantity;
      console.log(`No conversion needed: Units match, returning ${result}`);
      return result;
    }
  
    // Find conversion mapping
    const mapping = mappings.find((m) => {
      const fromUnitStr = String(m.fromUnit.id || m.fromUnit);
      const toUnitStr = String(m.toUnit.id || m.toUnit);
      const match = fromUnitStr === toUnitId && toUnitStr === fromUnitId;
      console.log(`Checking mapping: ${fromUnitStr} -> ${toUnitStr}, Match: ${match}`);
      return match;
    });
  
    let convertedQuantity = item.quantity;
    if (convert && mapping) {
      convertedQuantity = item.quantity * (1 / mapping.conversionFactor);
      console.log(
        `Converted ${item.quantity} from ${toUnitId} to ${fromUnitId}, Factor: ${
          1 / mapping.conversionFactor
        }, Result: ${convertedQuantity}`
      );
    } else {
      console.log(
        `No conversion applied: ${item.quantity} remains in ${toUnitId}, Mapping: ${
          mapping ? "found" : "not found"
        }, Convert: ${convert}`
      );
    }
  
    // Negate for sales
    convertedQuantity *= type === "sale" ? 1 : 1;
    console.log(`Final quantity (after negation): ${convertedQuantity}`);
  
    return convertedQuantity;
  };
  const convertPrice = (item, fromUnitId, toUnitId) => {
    console.log('convertPrice inputs:', { item, fromUnitId, toUnitId });
  
    // Validate item structure
    if (!item?.price || !fromUnitId || !toUnitId) {
      console.error('Invalid item structure for price conversion:', item);
      return 0;
    }
  
    const sourceUnitId = String(fromUnitId);
    const targetUnitId = String(toUnitId);
  
    console.log(`sourceUnitId: ${sourceUnitId}, targetUnitId: ${targetUnitId}`);
  
    // If units match, return price unchanged
    if (sourceUnitId === targetUnitId) {
      console.log(`No conversion needed: Units match, returning ${item.price}`);
      return item.price;
    }
  
    // Find conversion mapping
    const mapping = mappings.find((m) => {
      const fromUnitStr = String(m.fromUnit.id || m.fromUnit);
      const toUnitStr = String(m.toUnit.id || m.toUnit);
      const match = fromUnitStr === sourceUnitId && toUnitStr === targetUnitId;
      console.log(`Checking mapping: ${fromUnitStr} -> ${toUnitStr}, Match: ${match}`);
      return match;
    });
  
    let convertedPrice = item.price;
    if (mapping) {
      convertedPrice = item.price * mapping.conversionFactor;
      console.log(
        `Converted ${item.price} from ${sourceUnitId} to ${targetUnitId}, Factor: ${
          mapping.conversionFactor
        }, Result: ${convertedPrice}`
      );
    } else {
      console.warn(
        `No mapping found for ${sourceUnitId} to ${targetUnitId}. Returning original price: ${item.price}`
      );
    }
  
    return convertedPrice;
  };
  // const getConvertedQuantity = (item, type = "sale", targetUnitId, convert = true) => {
  //   try {
  //     const toUnitId = String(item?.units?.[type]?.unit?.id); // Sale unit ID
  //     const fromUnitId = String(targetUnitId || item?.units?.stock?.unit?.id); // Stock unit ID or target unit
  
  //     // If sale unit matches stock unit (or target unit), return original quantity
  //     if (toUnitId === fromUnitId) {
  //       console.log(`No conversion needed: Sale unit ${toUnitId} matches stock unit ${fromUnitId} , Returning: ${item.quantity}`);
  //       return item.quantity; // Return original quantity without negation
  //     }
  
  //     // Find conversion mapping
  //     const mapping = mappings.find((m) => {
  //       const fromUnitStr = String(m.fromUnit.id || m.fromUnit);
  //       const toUnitStr = String(m.toUnit.id || m.toUnit);
  //       const match = fromUnitStr === toUnitId && toUnitStr === fromUnitId;
  //       console.log(`Checking mapping: ${fromUnitStr} -> ${toUnitStr}, Match: ${match}`);
  //       return match;
  //     });
  
  //     let convertedQuantity = item.quantity;
  //     if (convert && mapping) {
  //       convertedQuantity = item.quantity * (1 / mapping.conversionFactor);
  //       console.log(`Converted ${item.quantity} from ${toUnitId} to ${fromUnitId}, Factor: ${1 / mapping.conversionFactor}, Result: ${convertedQuantity}`);
  //       convertedQuantity *= (type === "sale" ? -1 : 1); // Negate only if converting
  //     } else {
  //       console.log(`No conversion applied: ${item.quantity} remains in ${toUnitId}`);
  //     }
  
  //     return convertedQuantity;
  //   } catch (error) {
  //     console.log(error);
  //     return 0;
  //   }
  // };
  const contextValue = {
    stock,
    trackStock,
    setTrackStock,
    getCurrentStockQty,
    getConvertedQuantity,
    convertPrice
  };

  return (
    <StockContext.Provider value={contextValue}>
      {children}
    </StockContext.Provider>
  );
};

export { StockContext, StockProvider };